import { createContext } from "react";

const GastosContext = createContext();

export default GastosContext;
